import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./TabStyles.css";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import AssignmentIcon from "@mui/icons-material/Assignment";
import WorkIcon from "@mui/icons-material/Work";
import logo from "url:../../public/logo.png";
import { CgMenu } from "react-icons/cg";
import { CgClose } from "react-icons/cg";

function NavigationTabs() {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggleNav = () => setIsNavVisible(!isNavVisible);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isNavVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isNavVisible]);

  const tabs = [
    { path: "/", name: "Home", Icon: HomeIcon },
    { path: "/our-services", name: "Our Services", Icon: WorkIcon },
    { path: "/our-industries", name: "Our Industries", Icon: AssignmentIcon },
    { path: "/our-team", name: "Our People", Icon: PeopleIcon },
    {
      path: "/contact-information",
      name: "Contact Us",
      Icon: ContactSupportIcon,
    },
  ];

  const currentTab =
    tabs.find((tab) => tab.path === location.pathname)?.name || "Home";

  return (
    <div className={`tab-container ${scrolled ? "scrolled" : ""}`}>
      <img src={logo} alt="Logo" className="navbar-logo" />

      <CgMenu className="hamburger-menu-icon" onClick={toggleNav} />

      {!isNavVisible && <div className="current-tab-title">{currentTab}</div>}

      {isNavVisible && <div className="overlay" onClick={toggleNav}></div>}

      <div className={`mobile-nav ${isNavVisible ? "visible" : ""}`}>
        <div className="mobile-nav-header">
          <img src={logo} alt="Logo" className="mobile-logo" />
          <CgClose className="close-icon" onClick={toggleNav} />
        </div>

        <div className="mobile-nav-content">
          {tabs.map((tab, index) => (
            <NavLink
              key={index}
              to={tab.path}
              className={({ isActive }) =>
                isActive ? "nav-item active" : "nav-item"
              }
              onClick={toggleNav}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="nav-icon-wrapper">
                <tab.Icon />
              </div>
              <span className="nav-text">{tab.name}</span>
              <div className="nav-arrow">→</div>
            </NavLink>
          ))}
        </div>
      </div>

      <ul className="tab-list">
        {tabs.map((tab, index) => (
          <li key={index} className="tab-list-item">
            <NavLink
              to={tab.path}
              className={({ isActive }) =>
                isActive ? "tab-link active" : "tab-link"
              }
            >
              <tab.Icon className="tab-icon" />
              <span className="tab-name">{tab.name}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default NavigationTabs;
